import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/jensen'

Styxie.Initializers.JensenIncomingCalls = {
  index: async(props) => {
    const { default: IncomingCallsIndex } = await import('@/vue_widgets/jensen/incoming_calls/index.vue')
    createVueApp(IncomingCallsIndex, { props, sidebar })
  },

  show: async(props) => {
    const { default: IncomingCallsShow } = await import('@/vue_widgets/jensen/incoming_calls/show.vue')
    createVueApp(IncomingCallsShow, { props, sidebar })
  }
}
